var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.pageTitle))]),_c('b-breadcrumb',{attrs:{"items":_vm.breadcrumbItems}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }